<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-inner-icon="event"
        readonly
        v-on="on"
        @input="handleInput"
        clearable
        :error="error"
        :rules="rules"
        :disabled="disabled"
      ></v-text-field>
      <!-- allowed-dates="['2019-10-01']" -->
    </template>
    <v-date-picker v-model="date" no-title scrollable :min="min" :max="max">
      <v-spacer></v-spacer>
      <v-btn flat  @click="menu = false">Cerrar</v-btn>
      <v-btn flat  @click="$refs.menu.save(date); $emit('input', date)">Seleccionar</v-btn>
    </v-date-picker>
  </v-menu>

</template>


<script>
  import moment from 'moment'
  export default {
    props:["value","label","error","rules","min","max","dark","disabled","currentDate"],
    data: () => ({
      date: null,
      menu: false,
    }),
    watch : {

    },
    created(){

    },
    mounted(){

      if(this.value){
        let date_temp = this.value.toString();
        this.date = date_temp;
      }

      if(this.currentDate){
        let today = new Date();
        this.date = moment(today).format('YYYY-MM-DD');
        this.$emit('input', this.date);
      }
    },
    methods: {
      handleInput (e) {
        this.$emit('input', this.date)
      }
    }
  }
</script>
